/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs */

const en_admin_dashboard_invoice_tags_visitor_attendance = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Visitor Tickets`)
};

const de_admin_dashboard_invoice_tags_visitor_attendance = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event-Besuchertickets`)
};

const es_admin_dashboard_invoice_tags_visitor_attendance = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entradas de visitantes a eventos`)
};

const fr_admin_dashboard_invoice_tags_visitor_attendance = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billets visiteurs pour événements`)
};

const it_admin_dashboard_invoice_tags_visitor_attendance = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biglietti visitatori eventi`)
};

const pt_br2_admin_dashboard_invoice_tags_visitor_attendance = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingressos de evento (visitantes)`)
};

const pl_admin_dashboard_invoice_tags_visitor_attendance = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilety dla gości wydarzeń`)
};

const hu_admin_dashboard_invoice_tags_visitor_attendance = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esemény látogatói jegyek`)
};

const ro_admin_dashboard_invoice_tags_visitor_attendance = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilete Vizitatori Evenimente`)
};

/**
* | output |
* | --- |
* | "Event Visitor Tickets" |
*
* @param {Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_visitor_attendance = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_Visitor_AttendanceInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_visitor_attendance(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_visitor_attendance(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_visitor_attendance(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_visitor_attendance(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_visitor_attendance(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_visitor_attendance(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_visitor_attendance(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_visitor_attendance(inputs)
	return ro_admin_dashboard_invoice_tags_visitor_attendance(inputs)
});
export { admin_dashboard_invoice_tags_visitor_attendance as "admin.dashboard.invoice_tags.visitor_attendance" }